module.exports = __webpack_public_path__ + "static/media/ShuffleTile.b8bfbc17.jpg";